import { render, staticRenderFns } from "./FormPersonalInfo.vue?vue&type=template&id=8db1dd6a&scoped=true"
import script from "./FormPersonalInfo.vue?vue&type=script&lang=js"
export * from "./FormPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./FormPersonalInfo.vue?vue&type=style&index=0&id=8db1dd6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db1dd6a",
  null
  
)

export default component.exports